import axios from 'axios';
import { emitErrorNotification, emitSuccessNotification } from '../utils/notifications';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3010/api';

console.log('🔗 API Base URL:', API_BASE_URL); // Debug: verify env variable is loaded

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    const method = (response.config?.method || 'get').toLowerCase();
    const message = response.data?.message;

    if (method !== 'get' && message) {
      emitSuccessNotification(message);
    }

    return response;
  },
  (error) => {
    const authFailureMessages = new Set([
      'Authentication required',
      'Invalid or expired token',
      'User not found',
    ]);

    if (
      error.response?.status === 401 &&
      authFailureMessages.has(error.response?.data?.message)
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      const currentUrl = `${window.location.pathname}${window.location.search}`;
      const loginUrl = new URL('/login', window.location.origin);
      if (currentUrl && currentUrl !== '/login') {
        loginUrl.searchParams.set('returnUrl', currentUrl);
      }

      window.location.href = loginUrl.toString();
    }

    const validationErrors = error.response?.data?.errors;
    const message = Array.isArray(validationErrors) && validationErrors.length > 0
      ? validationErrors.map((item) => item.message).join(', ')
      : error.response?.data?.message || error.message || 'Something went wrong';

    emitErrorNotification(message);

    return Promise.reject(error);
  }
);

export default api;
